import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { MechanismReveal } from './components/MechanismReveal';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-night-500 text-night-50 font-sans selection:bg-amber-warm/30 selection:text-amber-glow" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPoints data-id="element-3" />
        <MechanismReveal data-id="element-4" />
        <OfferSection data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}